export const IMAGE_MAP = {
    'JEE(A)': 'jeeA',
    'JEE(M)':'jeeM',
    'BITSAT':'bitsat',
    'NTSE & Fundamentals of Engineering and Medical' : 'ntse',
};

export const API_ERROR = 'Some error occured while fetching data';
